import { useEffect, type ReactNode } from 'react';

import { useAuthStore } from '@/features/auth/store';

interface AuthInitializerProps {
  children: ReactNode;
}

export const AuthInitializer = ({ children }: AuthInitializerProps) => {
  const { checkAuth } = useAuthStore(state => state.actions);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return <>{children}</>;
};
